var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 19.5L50.0575 28.205C50.2457 28.3303 50.4644 28.4021 50.6903 28.4129C50.9161 28.4237 51.1407 28.3731 51.34 28.2664C51.5393 28.1596 51.706 28.0008 51.8222 27.8069C51.9384 27.6129 51.9999 27.3911 52 27.165V6.675C52.0001 6.45506 51.9421 6.23899 51.8319 6.04862C51.7218 5.85825 51.5634 5.70031 51.3727 5.59075C51.1819 5.48119 50.9657 5.42389 50.7458 5.42464C50.5258 5.42538 50.31 5.48415 50.12 5.595L37 13.25M7 2H32C34.7614 2 37 4.23858 37 7V27C37 29.7614 34.7614 32 32 32H7C4.23858 32 2 29.7614 2 27V7C2 4.23858 4.23858 2 7 2Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d7a9a946057dd67b638a9ad2a7a06e10.svg";
export { ForwardRef as ReactComponent };